import React from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getYangoClaim } from '../../../../../actions';

const YangoCheckClaimButton = ({ dispatchGetYangoClaim, deliveryId }) => {
  const startDelivery = () => {
    dispatchGetYangoClaim({ deliveryId });
  };

  const renderButton = () => (
    <Button color="success" onClick={startDelivery}>
      <i className="fa fa-refresh" /> Revisar Estado de Entrega Yango
    </Button>
  );

  return <>{renderButton()}</>;
};

YangoCheckClaimButton.propTypes = {
  dispatchGetYangoClaim: PropTypes.func.isRequired,
  deliveryId: PropTypes.number.isRequired,
};

const mapDispatchToProps = {
  dispatchGetYangoClaim: getYangoClaim,
};

export default connect(null, mapDispatchToProps)(YangoCheckClaimButton);
